<button mat-raised-button [ngClass]="confirmedComponents?.includes(widgetName) ? 'bg-success text-white' : 'bg-warning'"
        type="button"
        class="ms-2"
        (click)="confirmDetails(widgetName)">
  <div class="d-flex align-items-center">
    <ng-container *ngIf="!confirmedComponents?.includes(widgetName)">
      <i class="material-icons md-18 confirmation-icon">radio_button_unchecked</i> <mat-label class="ms-3">Click here to confirm details</mat-label>
    </ng-container>
    <ng-container *ngIf="confirmedComponents?.includes(widgetName)">
      <i class="material-icons md-18 confirmation-icon">check_circle</i> <mat-label class="ms-3">Details confirmed</mat-label>
    </ng-container>
  </div>
</button>
